import { NamePath } from "rc-field-form/es/interface";

export const makeNamePath = (...paths: (NamePath | undefined)[]) =>
  paths.map((p) => (p !== undefined ? (p instanceof Array ? p : [p]) : [])).flat(1);
